import React from 'react';
import {Row} from "react-flexbox-grid";


const ipscss = {
    marginLeft: '0px',
    marginRight: '0px'
}
const AssetMappingHeader = () => {
    return(
        <>
            <Row style={ipscss} className= "pre-status--row asset-table-header">
                <div className="col-xs">
                    <strong>Asset Name</strong>
                </div>
                <div className="col-xs" style={{textAlign: "center"}}>
                    <strong>Asset Group</strong>
                </div>
                <div className="col-xs" style={{textAlign: "center"}}>
                    <strong>IPS Asset Status</strong>
                </div>
            </Row>
        </>
    )
}
export default AssetMappingHeader;